module.exports = __webpack_public_path__ + "img/2_Dang_xu_ly.ef623446.png";